import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@redux/reducers/rootReducer';

const commonCompaniesDnb = (state: RootState) => state.common.companiesDnb;

const getListState = createSelector(commonCompaniesDnb, (state) => state);

export const companiesDnbSelectors = { getListState };
